module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAPFBMVEUWm2L/iD7////z+vf/+fUioGoEk1b/jkj/fy8Wm2L/iD7///8Wm2L/iD7z+vf/+fUioGoEk1b/jkj/fy9txuyGAAAAC3RSTlPy8vLy8vLy8vLl5aFJJM4AAABUSURBVFjD7da3EQAhFMTQ5bw30H+vNLDhDxhGKuDF0i7XMo+DbVq35Dp02f7vOW1vLrdNioESEBAQEBAQEFAvUNRoha0fDwkEBAQEBAQE1DzU3ENWtcrogdLmHTsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/buttonCulture/ie.png
// module id = 450
// module chunks = 0